import React, { Fragment } from 'react'
import { Button } from '@drifthq/tide-core'
import PasswordInput from 'components/PasswordInput'
import { meetsAllRequirements } from 'utils/password'
import './style.css'

const canSubmit = (password, config, passwordConfigFetched) => {
  if (passwordConfigFetched) {
    return meetsAllRequirements(password, config)
  } else {
    return !!password
  }
}

const showWarning = (password, config, passwordUpdateStatus) => {
  return passwordUpdateStatus === 'failed' &&
    !meetsAllRequirements(password, config)
}

export const PasswordStep = ({
  password,
  onPasswordChange,
  onContinueClick,
  passwordConfig,
  passwordConfigFetched,
  passwordUpdateStatus
}) => {
  return (
    <Fragment>
      <h1>Set a Password</h1>
      <PasswordInput
        value={password}
        passwordConfig={passwordConfig}
        passwordConfigFetched={passwordConfigFetched}
        passwordUpdateStatus={passwordUpdateStatus}
        onChange={onPasswordChange}
      />
      {!passwordConfigFetched && <Button className="no-password-hints-button" onClick={onContinueClick} disabled={!canSubmit(password, passwordConfig, passwordConfigFetched)}>Next</Button> }
      {passwordConfigFetched && <Button onClick={onContinueClick} disabled={!canSubmit(password, passwordConfig, passwordConfigFetched)}>Next</Button> }
      {showWarning(password, passwordConfig, passwordUpdateStatus) && <strong className="reset-password-error">
        Your password is almost secure! Make sure that you meet all requirements.
      </strong> }
    </Fragment>
  )
}

export const AEPasswordStep = ({
  password,
  onPasswordChange,
  onContinueClick,
  isCalendarSeat,
  passwordConfig,
  passwordConfigFetched,
  passwordUpdateStatus
}) => {
  return (
    <Fragment>
      <h1>Activate your Drift Account</h1>
      <p>Just set your password!</p>
      <PasswordInput
        value={password}
        passwordConfig={passwordConfig}
        passwordConfigFetched={passwordConfigFetched}
        passwordUpdateStatus={passwordUpdateStatus}
        onContinueClick={onContinueClick}
        onChange={onPasswordChange}
        configurableReqs={true}
      />
      {!passwordConfigFetched && <Button className="no-password-hints-button" onClick={onContinueClick} disabled={!canSubmit(password, passwordConfig, passwordConfigFetched)}>Activate account</Button>}
      {passwordConfigFetched && <Button onClick={onContinueClick} disabled={!canSubmit(password, passwordConfig, passwordConfigFetched)}>Activate account</Button> }
      {showWarning(password, passwordConfig, passwordUpdateStatus) && <strong className="reset-password-error">
        Your password is almost secure! Make sure that you meet all requirements.
      </strong> }
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/layouts/PasswordStep/component.js